export const LayoutFooter = (props) => {
    return (
        <div>PublishPress Future Workflow Editor</div>
    );
}
